

//Data imports
import SubMenuTab_OrderDependent from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_OrderDependent.vue";
import AccessMatrix from '@/router/access-matrix';

//View and component imports
import Title_Job from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Job.vue";
const ViewJob = () => import('@/views/job/viewjob/ViewJobContainer.vue')
const ViewJobGeneral = () => import('@/views/job/viewjob/ViewJobGeneral.vue')
const ViewCheckLists = () => import('@/views/job/viewjob/ViewJobCheckLists.vue')
const ViewJobPlanning = () => import('@/views/job/viewjob/ViewJobPlanning.vue')
const ViewJobLogg = () => import('@/views/job/viewjob/ViewJobLogg.vue')
//const ViewJobHistory = () => import('@/views/job/viewjob/ViewJobHistory.vue')
const ViewJobResources = () => import('@/views/job/viewjob/ViewJobResources.vue')

const ViewJobParts = () => import('@/views/job/viewjob/ViewJobParts.vue')
const ViewJobInvoice = () => import('@/views/job/viewjob/invoice/ViewJobInvoice.vue')
const EditTimeForm = () => import('@/views/job/viewjob/parts/EditTimeForm.vue')
const EditPartForm = () => import('@/views/job/viewjob/parts/EditPartForm.vue')
const AddTimeForm = () => import('@/views/job/viewjob/parts/AddTimeForm.vue')
const AddPartForm = () => import('@/views/job/viewjob/parts/AddPartForm.vue')

//Export item
const branch =  {
  meta: {
    authorize: AccessMatrix.JobsTrunk.viewjob_branch,
    icon: "$job",
    contextMenu: true,
    overrides: {
      sidebar: false,
      title: Title_Job,
    },
  },
  path: "view/:jobId",
  name: "ViewJob",
  redirect: { name: 'ViewJobGeneral' },
  component: ViewJob,
  children: [
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_general" },
        icon: "mdi-home",
        overrides: {
          header: {
            buttons: ['DeleteJobBtn', 'CopyJobBtn', 'HazardAnalysisBtn', 'ServiceReportBtn', 'CompleteJobBtn', 'ApproveJobBtn'],
          },
        }
      },
      path: "general",
      name: "ViewJobGeneral",
      component: ViewJobGeneral
    },

    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_planning" },
        icon: "mdi-calendar",
        overrides: {
          header: {
            buttons: ['NewAppointmentBtn'],
          },
        }
      },
      path: "planning/:appointmentId?",
      name: "ViewJobPlanning",
      component: ViewJobPlanning
    },
    {
      meta: {
        licenceEnabled: "CheckList",
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        displayName: "CheckList",
        icon: "mdi-timeline-text",
      },
      path: "checklists",
      name: "ViewCheckLists",
      component: ViewCheckLists
    },

    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_logg" },
        icon: "mdi-timeline-text",
      },
      path: "logg",
      name: "ViewJobLogg",
      component: ViewJobLogg
    },
    /*
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_history" },
        icon: "mdi-timeline-text",
      },
      path: "history",
      name: "ViewJobHistory",
      component: ViewJobHistory
    },
    */
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.common_objects.document.resources" },
        icon: "mdi-folder-open",
        overrides: {
          header: {
            buttons: ['ServiceReportBtn'],
          },
        }
      },
      path: "resources",
      name: "ViewJobResources",
      component: ViewJobResources
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_order" },
        icon: "mdi-hammer-wrench",
        overrides: {
          submenutab: SubMenuTab_OrderDependent,
        },
        contextMenu: 'Inherit',
      },
    
      path: "parts",
      name: "ViewJobParts",
      component: ViewJobParts,
      children: [
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Edit part',
            icon: "mdi-hammer-wrench",
          },
          name: "JobEditPart",
          path: "editpart/:machineJobId/:partId?",
          component: EditPartForm,
        },
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Edit time',
            icon: "mdi-clock-edit",
          },
          name: "JobEditTime",
          path: "edittime/:machineJobId/:timeId?",
          component: EditTimeForm,
        },
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Add Part',
            icon: "mdi-hammer-wrench",
          },
          name: "JobAddPart",
          path: "addpart/:machineJobId",
          component: AddPartForm,
        },
        {
          meta: {
            authorize: AccessMatrix.JobsTrunk.viewjob_branch,
            displayName: 'Add Time',
            icon: "mdi-clock-plus",
          },
          name: "JobAddTime",
          path: "addtime/:machineJobId",
          component: AddTimeForm,
        }
      ]
    },
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.viewjob_branch,
        display: { key: "servicesystem.pages.page_titles.job_view_job_pre_invoice" },
        icon: "mdi-cash-multiple",
        overrides: {
          header: {
            buttons: ['DeleteJobBtn', 'HazardAnalysisBtn', 'ServiceReportBtn', 'CompleteJobBtn', 'ApproveJobBtn'],
          },
          submenutab: SubMenuTab_OrderDependent,
        }
      },
      path: "invoice",
      name: "ViewJobInvoice",
      component: ViewJobInvoice
    },
  ]
};

export default branch;
